module.exports = __webpack_public_path__ + "img/创建引脚3.edc7ef2a.svg";